import auth from "@/middleware/auth";
import admin from "@/middleware/admin";

export const medicineLeadingRoutes = [
  {
    path: "/directories/medicine-leading",
    name: "MedicineLeadingList",
    meta: { middleware: [auth, admin] },
    component: () =>
      import(/* webpackChunkName: "medicineLeading" */ "./components/List"),
  },
];
